import _ from '@luna/lodash';
import { AjaxErrorDetailFactory } from '@shared/statistics';
import type { AjaxErrorTrackService } from '@shared/statistics';
import type { GeorgeJQueryXHR } from '@shared/core-types';

const ROUND_TRIP_TIME_MAX = 6000;
const API_WARNING_TYPE = 'WARNING';
const API_WARNING_RTT_NAME = 'WARNING_API_ROUND_TRIP_TIME';

export class AjaxTimeTracker {
    constructor(
        private JQDocument: JQuery<Document>,
        private errorTracker: AjaxErrorTrackService,
    ) {
        this.JQDocument = JQDocument;
        this.errorTracker = errorTracker;
    }

    start(): void {
        this.JQDocument.ajaxSend(this.onAjaxSend);
        this.JQDocument.ajaxComplete(this.onAjaxComplete);
    }

    onAjaxSend = (settings: JQueryAjaxSettings, xhr: GeorgeJQueryXHR): void => {
        AjaxTimeTracker.addStartTime(xhr);
    };

    static addStartTime(xhr: GeorgeJQueryXHR): void {
        _.set(xhr, 'startTime', AjaxTimeTracker.getTime());
    }

    onAjaxComplete = (
        event: JQuery.TriggeredEvent<Document>,
        xhr: GeorgeJQueryXHR,
        settings: JQueryAjaxSettings,
    ): void => {
        AjaxTimeTracker.addRoundTrip(xhr);
        this.trackLongCall(xhr, settings);
    };

    trackLongCall(xhr: GeorgeJQueryXHR, settings: JQueryAjaxSettings): void {
        if (xhr.roundTrip && xhr.roundTrip >= ROUND_TRIP_TIME_MAX) {
            const errorDetail = AjaxErrorDetailFactory.create(settings, xhr);
            this.errorTracker.track(API_WARNING_TYPE, API_WARNING_RTT_NAME, errorDetail);
        }
    }

    static addRoundTrip(xhr: GeorgeJQueryXHR): void {
        const roundTrip = AjaxTimeTracker.getTime() - _.get(xhr, 'startTime', 0);
        _.set(xhr, 'roundTrip', roundTrip);
    }

    static getTime(): number {
        return new Date().getTime();
    }
}
